<div
  class="autonomy-badge-wrapper"
  (click)="togglePopover()"
  cdkOverlayOrigin
  #levelBadgeOrigin="cdkOverlayOrigin"
  role="button"
>
  <glxy-badge class="level-indicator-badge">
    <span class="label">{{ label() }}</span>
    <div class="indicators">
      @for (i of levels; track i) {
        <div class="indicator" [class.filled]="value() > i"></div>
      }
    </div>
  </glxy-badge>
</div>

@if (showPopover) {
  <glxy-popover
    [origin]="levelBadgeOrigin"
    [isOpen]="true"
    [showBackdrop]="true"
    [hasBackdrop]="true"
    [hasArrow]="true"
    [positions]="[PopoverPositions.Top, PopoverPositions.Right, PopoverPositions.Bottom]"
    (backdropClick)="closePopover()"
    [keepOnScreen]="true"
  >
    @let autonomy = aiAssistant().autonomyRating | autonomyLevel;
    <glxy-popover-title>
      {{
        'AI_ASSISTANT.AUTONOMY_LEVELS.LEVEL_TITLE_FORMAT'
          | translate: { level: autonomy.level, title: (autonomy.levelTitle | translate) }
      }}
    </glxy-popover-title>
    {{ autonomy.levelDescription | translate }}
  </glxy-popover>
}
